import React from 'react';
import { FoodTemperatureProvider } from './context/FoodTemperatureContext';
import DefaultLayout from '../../../layouts/default';
import FoodTemperatureCheckHeader from './components/FoodTemperatureCheckHeader';
import TodaysTemperatureLogTable from './components/TodaysTemperatureLogTable';
import TemperatureGuidelines from './components/TemperatureGuidelines';
import TemperatureMetricsDashboard from './components/TemperatureMetricsDashboard';
import ManagerSignOff from './components/ManagerSignOff';
import AddTemperatureEntryForm from './components/AddTemperatureEntryForm';
import CheckSummaryCard from './components/CheckSummaryCard';

function FoodTemperatureCheckPage() {

  return (
    <DefaultLayout>
      <FoodTemperatureProvider>
        <FoodTemperatureCheckHeader />
        <TemperatureMetricsDashboard />
        <AddTemperatureEntryForm />
        <TodaysTemperatureLogTable />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-6">
            <TemperatureGuidelines />
            <CheckSummaryCard />
        </div>
        <ManagerSignOff />
      </FoodTemperatureProvider>
    </DefaultLayout>
  );
}

export default FoodTemperatureCheckPage;

